import { useNavigate } from "react-router-dom";
import { useUserSelector } from "@context/hooks";
import { getBaseRoute } from "@utils/route";
import { mapGradeCodeToGradeParamId } from "@utils/routeUtil";
import { useEffect } from "react";
import { REQUEST_STATUS } from "@ts/enums/RequestStatus";
import { GRADE_STATUS } from "@ts/enums/GradeStatus";
import { PageLoader } from "@euka-mfes/bark";
import {
  getOrientationStartUrl,
  shouldRedirectToOrientation
} from "@/utils/orientation";

const StartupRedirectPage = () => {
  const navigate = useNavigate();
  const { selectedGrade, headerDetails, getHeaderDetailsRequestStatus } =
    useUserSelector();

  useEffect(() => {
    if (getHeaderDetailsRequestStatus !== REQUEST_STATUS.SUCCESS) return;

    // If no grade found, send to not access page as a safe default
    if (!headerDetails.grades?.length) {
      navigate(`${getBaseRoute()}no-access`, { replace: true });
      return;
    }

    const grade =
      selectedGrade ??
      headerDetails.grades.find(g => g.status === GRADE_STATUS.CURRENT) ??
      headerDetails.grades[0];

    const gradeParam = grade
      ? mapGradeCodeToGradeParamId(grade.grade_code)
      : undefined;

    if (
      shouldRedirectToOrientation({
        orientationEnabled: headerDetails.orientationEnabled,
        grade
      })
    ) {
      navigate(
        getOrientationStartUrl(
          grade.grade_code,
          headerDetails.userState?.introScreenSeen
        ),
        { replace: true }
      );
      return;
    }

    // Append the grade to the base and land on the canonical first page (e.g., learning/{grade})
    navigate(
      gradeParam
        ? `${getBaseRoute()}${gradeParam}`
        : `${getBaseRoute()}no-access`,
      { replace: true }
    );
  }, [
    getHeaderDetailsRequestStatus,
    headerDetails.grades,
    headerDetails.orientationEnabled,
    headerDetails.userState?.introScreenSeen,
    selectedGrade
  ]);

  return <PageLoader overlayColor="gradeTheme.pageBg" />;
};

export default StartupRedirectPage;
